document.addEventListener('DOMContentLoaded', function () {
  const letterButtons = document.querySelectorAll('.a-to-z-search__item');
  letterButtons.forEach(button => {
    button.addEventListener('click', function () {
      const letter = this.dataset.letter;
      const targetCategory = document.querySelector(`.a-to-z-search__category[data-letter="${letter}"]`);
      if (targetCategory) {
        targetCategory.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  const cartContainer = document.querySelector('.category-test-cart-popup__count-content');
  const countNumber = document.querySelector('.category-test-cart-popup__count-number');
  const ctaButton = document.querySelector('.category-test-cart-popup__cta');

  let selectedProducts = [];

  cartContainer.innerHTML = '';
  updateCount();

  function initAddButtons() {
    const addButtons = document.querySelectorAll('.a-to-z-search__add-enquiry');
    addButtons.forEach(button => {
      button.addEventListener('click', function () {
        const productItem = this.closest('.a-to-z-search__test-item');
        const productName = productItem.dataset.productName;

        if (selectedProducts.includes(productName)) {
          removeFromCart(productName);
        } else {
          addToCart(productName);
        }
      });
    });
  }

  function initAddAllButtons() {
    const addAllButtons = document.querySelectorAll('.country-selector__countries-content__add-all-cta');
    addAllButtons.forEach(button => {
      button.addEventListener('click', function () {
        const testsContainer = this.closest('.country-selector__countries-content__item').querySelector('.a-to-z-search__tests');
        const testItems = testsContainer.querySelectorAll('.a-to-z-search__test-item');
        testItems.forEach(item => {
          const productName = item.dataset.productName;
          if (!selectedProducts.includes(productName)) {
            addToCart(productName);
          }
        });
      });
    });
  }

  function addToCart(name) {
    if (selectedProducts.includes(name)) return; // avoid duplicates

    selectedProducts.push(name);
    renderCartItem(name);
    updateCount();
    updateButtonStates();
  }

  function removeFromCart(name) {
    selectedProducts = selectedProducts.filter(n => n !== name);

    const cartButton = cartContainer.querySelector(`[data-product-name="${CSS.escape(name)}"]`);
    if (cartButton) cartButton.remove();

    updateCount();
    updateButtonStates();
  }

  function renderCartItem(name) {
    const button = document.createElement('button');
    button.classList.add('category-test-cart-popup__item');
    button.dataset.productName = name;
    button.innerHTML = `
      <span>${name}</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M18 6L6 18" stroke="#2C353B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6 6L18 18" stroke="#2C353B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    `;
    button.addEventListener('click', function () {
      removeFromCart(name);
    });
    cartContainer.appendChild(button);
  }

  function updateButtonStates() {
    const allButtons = document.querySelectorAll('.a-to-z-search__add-enquiry');
    allButtons.forEach(btn => {
      const parent = btn.closest('.a-to-z-search__test-item');
      const name = parent.dataset.productName;
      if (selectedProducts.includes(name)) {
        btn.classList.add('a-to-z-search__add-enquiry--active');
      } else {
        btn.classList.remove('a-to-z-search__add-enquiry--active');
      }
    });
  }

  function updateCount() {
    countNumber.textContent = selectedProducts.length;
  }

  
  ctaButton.addEventListener('click', function () {
    if (!selectedProducts || selectedProducts.length === 0) return;

    const baseUrl = new URL(this.dataset.baseUrl, window.location.origin);
    const params = new URLSearchParams(baseUrl.search);
    
    params.set('products', selectedProducts.join(','));
    baseUrl.search = params.toString();
    window.location.href = baseUrl.toString();
  });

  initAddButtons();
  initAddAllButtons();
});
